import React from 'react';
import T from 'prop-types';

import Button from '../Buttons/Button';

const QuickViewCloseButton = ({ size, className, onClose }) => (
  <Button size={size} shape="square" variant="secondary" className={className} onClick={onClose}>
    <span className="hicon-close-alt" />
  </Button>
);

QuickViewCloseButton.propTypes = {
  size: T.string,
  className: T.string,
  onClose: T.func.isRequired,
};

export default QuickViewCloseButton;
